export default __webpack_public_path__ + "static/media/_DSC0567.4e16c7c3.JPG";